import React, { useEffect, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { successToast } from '../../ui_kit/utilities/success_toast';
import { handleUserRedirect } from '../../../utils/userRedirect';
import { autofocusAll } from '../../../helpers';
import Context from '../../../utils/context';

import SignIn from '../sign_in';

export default function UsersSignIn({}) {
  let history = useHistory();
  const context = useContext(Context);
  useEffect(() => {
    autofocusAll();
  }, []);

  useEffect(() => {
    const showToast = window.localStorage.getItem('showDeactivationToast');
    if (showToast === 'true') {
      successToast('Your account has been deactivated. We hope to see you back soon!');
      window.localStorage.removeItem('showDeactivationToast');
    }

    // Handle admin logout - clear React auth state when redirected from admin logout
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('admin_logout') === 'true') {
      // Clear the current user in React context
      if (context.auth && typeof context.auth.getCurrentUser === 'function') {
        context.auth.currentUser = {};
      }
      // Remove the admin_logout parameter from URL
      urlParams.delete('admin_logout');
      const newSearch = urlParams.toString();
      const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '');
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  const location = useLocation();
  let returnTo = '';
  let searchParams = '';

  if (history.location.state) {
    searchParams = new URLSearchParams(history.location.state);
    returnTo = history.location.state;
    if (searchParams.get('return_to')) {
      returnTo = searchParams.get('return_to');
    }
  } else {
    searchParams = new URLSearchParams(location.search);
    if (searchParams.get('return_to')) {
      returnTo = searchParams.get('return_to');
    }
  }

  const onSuccess = (data) => {
    const isImpersonation = Boolean(data.user?.true_user && data.user.true_user.id !== data.user.id);
    handleUserRedirect(data.user, history, {
      isImpersonation,
      returnTo: data.returnTo,
    });
  };

  const onTwoFactorRequired = (data) => {
    if (data.status === '2fa_required') {
      history.push('/auth/2fa');
    }
  };

  return (
    <>
      <SignIn onSuccess={onSuccess} onTwoFactorRequired={onTwoFactorRequired} />
    </>
  );
}
